import { render, staticRenderFns } from "./expandable-item.vue?vue&type=template&id=d9338cc2&scoped=true"
import script from "./expandable-item.vue?vue&type=script&lang=js"
export * from "./expandable-item.vue?vue&type=script&lang=js"
import style0 from "./expandable-item.vue?vue&type=style&index=0&id=d9338cc2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9338cc2",
  null
  
)

export default component.exports